import { render, staticRenderFns } from "./CarrierProductFormInsurance.vue?vue&type=template&id=5c42c573&scoped=true&"
import script from "./CarrierProductFormInsurance.vue?vue&type=script&lang=ts&"
export * from "./CarrierProductFormInsurance.vue?vue&type=script&lang=ts&"
import style0 from "./CarrierProductFormInsurance.vue?vue&type=style&index=0&id=5c42c573&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c42c573",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
